export default "__VITE_ASSET__BOABPF5Q__"